import styled from 'styled-components';

export const LanguageSelector = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const LanguageButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
  transition: filter 0.7s ease;

  &:hover {
    filter: contrast(100%);
  }
`;

export const FlagImage = styled.img`
  width: 30px;
  height: 30px;
  filter: grayscale(100%);

  ${LanguageButton}:hover & {
    filter: contrast(70%);
  }

  ${LanguageButton}.active & {
    filter: contrast(100%);
  }
`;
